(function () {
  const MARKER_OPEN = '+';
  const MARKER_CLOSE = '−';

  function getRowParts(row) {
    return {
      toggle: row.querySelector('.guaja-cart-coupon-row__toggle'),
      panel: row.querySelector('.guaja-cart-coupon-row__panel'),
      marker: row.querySelector('.guaja-cart-coupon-row__marker'),
      input: row.querySelector('.guaja-cart-coupon-row__input'),
    };
  }

  function expandGuajaCouponRow(row) {
    if (!row) return;
    const { toggle, panel, marker, input } = getRowParts(row);
    if (!toggle || !panel) return;

    row.classList.add('is-open');
    panel.hidden = false;
    toggle.setAttribute('aria-expanded', 'true');
    if (marker) marker.textContent = MARKER_CLOSE;
    if (input) input.focus();
  }

  function collapseGuajaCouponRow(row) {
    if (!row) return;
    const { toggle, panel, marker } = getRowParts(row);
    if (!toggle || !panel) return;

    row.classList.remove('is-open');
    panel.hidden = true;
    toggle.setAttribute('aria-expanded', 'false');
    if (marker) marker.textContent = MARKER_OPEN;
  }

  function toggleGuajaCouponRow(row) {
    if (row.classList.contains('is-open')) {
      collapseGuajaCouponRow(row);
    } else {
      expandGuajaCouponRow(row);
    }
  }

  function initGuajaCouponRows(root) {
    root.querySelectorAll('[data-guaja-coupon-row]').forEach((row) => {
      if (row.dataset.guajaCouponInit === '1') return;
      row.dataset.guajaCouponInit = '1';

      const toggle = row.querySelector('.guaja-cart-coupon-row__toggle');
      if (!toggle) return;

      toggle.addEventListener('click', () => toggleGuajaCouponRow(row));
    });
  }

  window.GuajaCartCoupon = {
    collapse: collapseGuajaCouponRow,
    expand: expandGuajaCouponRow,
    init: initGuajaCouponRows,
  };

  document.addEventListener('DOMContentLoaded', () => {
    initGuajaCouponRows(document);
  });

  if (document.readyState !== 'loading') {
    initGuajaCouponRows(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    initGuajaCouponRows(event.target);
  });

  document.addEventListener('cart:updated', () => {
    const footer = document.getElementById('MinimogCartDrawerFooter');
    if (footer) initGuajaCouponRows(footer);
  });
})();
